import { FC } from 'react'

interface LoadingViewProps {
  message?: string
  fullScreen?: boolean
}

const LoadingView: FC<LoadingViewProps> = ({ message = 'Loading...', fullScreen = true }) => {
  return (
    <div className={`flex flex-col items-center justify-center p-4 ${fullScreen ? 'min-h-screen' : 'py-12'}`}>
      <div className="flex flex-col items-center space-y-6">
        <div className="w-24 h-24 rounded-full bg-[var(--brand-dark)] flex items-center justify-center shadow-lg">
          <img src="/logo_posacheck_symbol.png" alt="Posacheck Logo" className="w-16 h-16 object-contain" />
        </div>
        <span className="spinner spinner-lg" style={{ borderTopColor: 'var(--brand-red)' }} />
        <h2 className="text-lg font-medium text-center text-[hsl(var(--foreground))]">{message}</h2>
      </div>
    </div>
  )
}

export default LoadingView
